import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
const ApyCardLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-sm flex w-full flex-col"><Skeleton className="h-[395px] w-[100%] rounded-[20px]" /><Skeleton className="h-[162px] w-[100%] rounded-[20px] lg:hidden" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ApyCardLoading;